const NUMBERS = '0123456789';

/**
 * Get a random integer between min (inclusive) and max (exclusive)
 * @param {number} min 
 * @param {number} max 
 * @returns number
 */
export function getRandomInt(min, max) {
	const minCeiled = Math.ceil(min);
	const maxFloored = Math.floor(max);
	return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
}

export function generateId(length = 6, characters = NUMBERS) {
	let result = '';

	for (let i = 0; i < length; ++i) {
		result = `${result}${characters.charAt(Math.floor(Math.random() * characters.length))}`;
	}

	return result;
}

/**
 * Get a random avatar
 * @returns string URL of random avatar
 */
export function getRandomAvatarURL() {
	return `AvatarVV_${getRandomInt(1, 233).toString().padStart(4, '0')}.png`;
}
